<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="row">
    <app-calendar-modal [defect]='this.defect'></app-calendar-modal>
    <div class="col-md-4">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          >
          Previous
        </div>
        <div
          class="btn btn-outline-secondary"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          >
          Today
        </div>
        <div
          class="btn btn-primary"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
          >
          Next
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
          >
          Month
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
          >
          Week
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
          >
          Day
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      @if (this.calendarLoaded) {
        <div>
          @switch (view) {
            @case (CalendarView.Month) {
              <mwl-calendar-month-view
                [viewDate]="viewDate"
                [events]="events"
                [refresh]="refresh"
                [activeDayIsOpen]="activeDayIsOpen"
                (dayClicked)="dayClicked($event.day)"
                (eventClicked)="handleEvent('Clicked', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
                >
              </mwl-calendar-month-view>
            }
            @case (CalendarView.Week) {
              <mwl-calendar-week-view
                [viewDate]="viewDate"
                [events]="events"
                [refresh]="refresh"
                (eventClicked)="handleEvent('Clicked', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
                >
              </mwl-calendar-week-view>
            }
            @case (CalendarView.Day) {
              <mwl-calendar-day-view
                [viewDate]="viewDate"
                [events]="events"
                [refresh]="refresh"
                (eventClicked)="handleEvent('Clicked', $event.event)"
                (eventTimesChanged)="eventTimesChanged($event)"
                >
              </mwl-calendar-day-view>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
